import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import {
  BREAKPOINTS,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '../../core/constants';
import useTranslation from '../../hooks/useTranslation';
import { LocalesUnion } from '../../types/interfaces';

const Hero = styled(Container)`
  display: flex;
  flex-direction: row;

  @media ${BREAKPOINTS.md} {
    flex-direction: column;
    margin-top: 50px;
  }
`;

const SvgShadow = styled.svg`
  -webkit-filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0px 0px 20px rgba(0, 0, 0, 0.3));
  z-index: 1;
`;

const LeftHand = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  z-index: 1;
  flex-direction: column;
  line-height: 1;

  @media ${BREAKPOINTS.md} {
    align-items: center;
  }
`;

const Title = styled.h2`
  color: ${TEXT_PRIMARY};
  font-weight: 800;
  text-align: left;
  font-size: 60px;

  @media ${BREAKPOINTS.lg} {
    font-size: 40px;
  }

  @media ${BREAKPOINTS.md} {
    text-align: center;
    font-size: 30px;
  }
`;

const Description = styled.h5`
  max-width: 400px;
  color: ${TEXT_SECONDARY};
  margin-top: 20px;

  @media ${BREAKPOINTS.lg} {
    margin-top: 0px;
  }

  @media ${BREAKPOINTS.md} {
    text-align: center;
    max-width: 100%;
    margin-bottom: 50px;
    font-size: 16px;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

const RightHand = styled.div`
  flex: 1;
  display: block;
  align-items: flex-end;
`;

interface CProps {
  locale: LocalesUnion;
}

const HeroBlob: React.FC<CProps> = ({ locale }) => {
  const { t } = useTranslation(locale);

  return (
    <div>
      <Hero>
        <LeftHand>
          <Title>{t('HOMEPAGE_HERO_BLOB_TITLE')}</Title>
          <Description>{t('HOMEPAGE_HERO_BLOB_DESCRIPTION')}</Description>
        </LeftHand>
        <RightHand>
          <SvgShadow viewBox="70 10 100 105" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern
                id="img1"
                patternUnits="objectBoundingBox"
                height="100%"
                width="100%"
              >
                <image
                  href="/images/map.png"
                  x="-30"
                  y="0"
                  height="100"
                  width="180"
                />
              </pattern>
            </defs>
            <filter id="dropshadow" height="130%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
              <feOffset dx="2" dy="2" result="offsetblur" />
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.5" />
              </feComponentTransfer>
              <feMerge>
                <feMergeNode />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>
            <path
              filter="filter:url(#dropshadow)"
              fill="url(#img1)"
              d="M64,-19C71.1,1.2,56.9,30,36.7,42.9C16.5,55.8,-9.7,52.6,-19,42.1C-28.2,31.7,-20.4,13.8,-14.4,-4.8C-8.4,-23.5,-4.2,-42.8,12.1,-46.8C28.4,-50.7,56.8,-39.2,64,-19Z"
              transform="translate(100 60)"
            />
          </SvgShadow>
        </RightHand>
      </Hero>
    </div>
  );
};

export default HeroBlob;
